import { restApiActions } from 'redux/redux-actions';

export const broadCastGroupActions = restApiActions('users/broad-cast-groups');
export const singleBroadCastGroupActions = restApiActions('users/broad-cast-group');
